/**
 * Custom Vue Router navigation guard for handling specific cases before each route change.
 */
export function maBeforeEachGuard(to, from, next) {
  // route guards don't work on the same page redirect!
  if (to.name === from.name) {
    const hasMissingRequiredParams = to.meta?.requiredParams?.some(param => !to.params[param])
    const hasMissingRequiredQueries = to.meta?.requiredQueries?.some(query => !to.query[query])

    if (hasMissingRequiredParams || hasMissingRequiredQueries) {
      next(false)
      return
    }
  }

  next()
}
